<script lang="ts" setup>
  import { computed } from 'vue';
  import { useShared } from '@othercommerce/foundation';

  const props = defineProps({
    value: { type: [String, Number], required: false },
    code: { type: String, required: false },
    decimals: { type: Number, required: false },
  });

  const shared = useShared();

  const formatter = computed(() => {
    return new Intl.NumberFormat(shared.value.appLocale, {
      style: 'currency',
      currency: props.code || shared.value.activeCurrencyCode,
      minimumFractionDigits: props.decimals || shared.value.activeCurrencyDecimals,
      maximumFractionDigits: props.decimals || shared.value.activeCurrencyDecimals,
    });
  });

  const normalized = computed(() => {
    if (props.value !== undefined && props.value !== null) {
      const parsed = Number(props.value);
      return isNaN(parsed) ? null : parsed;
    }
    return null;
  });
</script>
<template>
  <data v-if="normalized !== null" :value="normalized" class="money">
    <slot v-bind="{ formatter, normalized }">
      {{ formatter.format(normalized) }}
    </slot>
  </data>
</template>
